import fileSaver from 'file-saver';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import t from './Supplier.type';
import * as SupplierService from '../../../services/supplier.service';
import { storeSetupToken } from '../../../services/auth.service';
import * as productcp from '../../../services/productcp.service';
import i18next from 'i18next';

export const fetchSupplierListAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplier(params);
    if (res.code === 200) {
      const suppliersList = res.data.doc.map((item, i) => {
        return item;
      });
      await dispatch({
        type: t.SUPPLIER_LIST,
        payload: suppliersList,
      });
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchTier1SupplierListAction = () => async (dispatch) => {
  try {
    const res = await SupplierService.getTier1Supplier();
    if (res.code === 200) {
      await dispatch({
        type: t.GET_TIER1,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const fetchAllTierSupplierListAction = () => async (dispatch) => {
  try {
    const res = await SupplierService.getAllTierSupplier();
    if (res.code === 200) {
      await dispatch({
        type: t.GET_ALL_TIER,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchProductSupplierListAction = (id) => async (dispatch) => {
  try {
    const res = await SupplierService.getProductSupplier(id);
    if (res.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_SUPPLIER,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchTier2AboveSupplierListAction = () => async (dispatch) => {
  try {
    const res = await SupplierService.getTier2HigherSupplier();
    if (res.code === 200) {
      await dispatch({
        type: t.GET_TIER2_ABOVE,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchFactorySupplierListAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getFactorySupplier(params);

    if (res.code === 200) {
      await dispatch({
        type: t.GET_FACTORY_SUPPLIERS,
        payload: res.data,
      });
      return res?.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addSupplier = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await SupplierService.addSupplier(data);
    if (res?.code === 200 && res.data) {
      const sup = {
        _id: res.data._id,
        email: res.data.email,
        companies: [data],
      };
      await dispatch({
        type: t.ADD_SUPPLIER,
        payload: sup,
      });
      toasterMsg(transactionMsg(res.message), 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteSupplier = (params, userID, transactionMsg) => async (dispatch) => {
  const res = await SupplierService.deleteSupplier(params, userID);
  if (res?.data && res.code === 200) {
    const msg = transactionMsg('SUPPLIER.BACKEND_CONTROLLER.SUPPLIER_DELETED');
    toasterMsg(msg, 'success');
  } else if (res?.data?.errMsg) {
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
  }
  try {
    await dispatch({
      type: t.DELETE_SUPPLIER,
      payload: params,
    });
    return res;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const updateSupplier = (id, params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.editSupplier(id, params);
    if (res?.data && res.code === 200) {
      const msg = transactionMsg('SUPPLIER.BACKEND_CONTROLLER.SUPPLIER_UPDATED');
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const supplierSuggestSwitchAction = (id, params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.supplierSuggestSwitch(id, params);
    if (res?.code === 200) {
      const msg = transactionMsg('SUPPLIER.BACKEND_CONTROLLER.SUPPLIER_UPDATED');
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateSupplierActiveStateAction = (id, isActive, transactionMsg) => async () => {
  try {
    const res = await SupplierService.updateSupplierActiveState(id, { isActive });
    if (res?.code === 200) {
      toasterMsg(transactionMsg('SUPPLIER.BACKEND_CONTROLLER.SUPPLIER_UPDATED'), 'success');
      return true;
    }
    toasterMsg(transactionMsg(SUPPLIER_STATE_FAILED_KEY), 'danger');
    return false;
  } catch (err) {
    const status = err?.response?.status;
    const serverKey = err?.response?.data?.message;
    const isClientError = status >= 400 && status < 500 && typeof serverKey === 'string' && serverKey !== '';
    toasterMsg(transactionMsg(isClientError ? serverKey : SUPPLIER_STATE_FAILED_KEY), 'danger');
    return false;
  }
};

export const integrateSupplierAction = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.integrateSupplier(params);
    if (res?.data && res.code === 200) {
      const msg = transactionMsg('SUPPLIER.BACKEND_CONTROLLER.SUPPLIER_CONFIRMATION');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSingleSupplierDetailsAction = (id) => async (dispatch) => {
  try {
    const res = await SupplierService.getSingleSupplierById(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.SUPPLIER_COMPONENT_FACTORY_LIST,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// Factory

export const clearFactory = (params) => async (dispatch) => {
  await dispatch({
    type: t.FACTORY_CLEAR,
    payload: params,
  });
};

export const fetchSupplierComponents = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getComponentSupplier(params.supplierId, params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SUPPLIER_COMPONENT_LIST,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const fetchSingleSupplierComponent = (id, supplier_id) => async (dispatch) => {
  try {
    const res = await SupplierService.getSingleFactoryById(id, supplier_id);
    if (res?.code === 200) {
      await dispatch({
        type: t.ONE_SUPPLIER_COMPONENT,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const addComponentSupplier = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await SupplierService.addComponentSupplier(params);
    if (res?.code === 200) {
      const { supplierTier } = params;
      const isTier2To4 = supplierTier && ['Tier2', 'Tier3', 'Tier4'].includes(supplierTier);
      const successMessage = isTier2To4
        ? 'EDIT_SUPPORTING_DOCUMENT.PRODUCTION_LOCATION_ADDED_SUCCESSFULLY'
        : 'EDIT_SUPPORTING_DOCUMENT.FACTORY_ADDED_SUCCESSFULLY';

      toasterMsg(transactionMsg(successMessage), 'success');
      await dispatch({
        type: t.ADD_SUPPLIER_COMPONENT,
        payload: { ...params, _id: res.data._id },
      });
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg.toString()), 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const editComponentSupplier = (params, data, transactionMsg) => async (dispatch) => {
  try {
    const res = await SupplierService.editComponentSupplier(params, data);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
      await dispatch({
        type: t.UPDATE_COMPONENET_SUPPLIER,
        payload: { params, data },
      });
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg.toString()), 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const deleteComponentSupplier = (params) => async () => {
  try {
    const res = await SupplierService.deleteComponentSupplier(params);
    if (res?.code === 200) {
      toasterMsg('Deleted Successfully', 'success');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const brandAndCategoryAssignmentAction = (brandAndcategoryData, arrayIndex) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_BRAND_AND_CATEGORY_ASSIGMENT,
      payload: { brandAndcategoryData, arrayIndex },
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchDocument = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.REARRANGING_DOCUMENTS,
      payload: params,
    });
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const rearrangedDocuments = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.DOCUMENT_LIST,
      payload: params,
    });
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const uploadDocument = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.uploadSupplierDocument(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`SUPPLIER_DOCUMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const editDocument = (documetnData, transactionMsg) => async () => {
  const res = await SupplierService.updateDocument(documetnData);
  try {
    if (res?.code === 200) {
      const msg = transactionMsg('SUPPLIER_DOCUMENT.BACKEND_SERVICE.DOCUMENT_UPDATED');
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const deleteDocument = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.deleteDocuments(params);
    if (res?.data && res.code === 200) {
      const msg = transactionMsg(`REQUIRED_DOCUMENT.${res.message}`);
      if (!params?.fromCancel) toasterMsg(msg, 'success');
      return res.code;
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const approveRejectDocuments = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.approveRejectDocuments(params);
    const msg = transactionMsg(`REQUIRED_DOCUMENT.${res.message}`);
    toasterMsg(msg, 'success');
    return res.code;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

// Critical Path (Bom Due Date)
export const fetchCriticalPath = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllBomDueDate(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.DUE_DATES_LIST,
        payload: res.data,
      });
    }
    return res;
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const addCriticalPath = (params, transactionMsg) => async () => {
  const res = await SupplierService.addBomDueDate(params);
  try {
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_DUE_DATE.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.message.toString()), 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const deleteCriticalPath = (params, transactionMsg) => async () => {
  const res = await SupplierService.deleteBomDueDate(params);
  try {
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_DUE_DATE.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.message.toString()), 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const reducerClear = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.DELETE_DUE_DATE,
      payload: params,
    });
  } catch (error) {}
};

// Supplier User Action Method
export const addSupplierUser = (params, lang) => async (dispatch) => {
  const data = params ? { ...params } : null;
  try {
    const res = await SupplierService.addSupplierUser(data);

    if (res?.code === 200 && res.data) {
      const msg = lang(`SUPPLIER.${res.message}`);

      const resData = {
        ...data,
        _id: res.data.userId,
      };
      await dispatch({
        type: t.ADD_USER,
        payload: resData,
      });
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data && res.data.errMsg) {
      toasterMsg(lang(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(lang(res.message), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierUser = (params) => async (dispatch) => {
  const data = params ? { ...params } : null;
  try {
    const res = await SupplierService.getSupplierUserById(data);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: t.GET_USER,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editSupplierUser = (params, id, lang) => async (dispatch) => {
  const data = params ? { ...params } : null;

  try {
    const res = await SupplierService.editSupplierUserById(id, data);

    if (res?.code === 200 && res.data) {
      const msg = lang(`SUPPLIER.${res.message}`);

      await dispatch({
        type: t.EDIT_USER,
        payload: { params, id },
      });
      toasterMsg(msg, 'success');
      return res.code;
    }
    if (res?.data && res.data.errMsg) {
      toasterMsg(lang(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(lang(res.message), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteUser = (params, id, transactionMsg) => async () => {
  try {
    const res = await SupplierService.deleteSupplierUserById(id, params);
    if (res?.code === 200 && res.data) {
      toasterMsg(transactionMsg(res.message), 'success');
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateUserStatus = (params, id) => async () => {
  try {
    const res = await SupplierService.updateSupplierUserStatusById(id, params);
    if (res?.code === 200 && res.data) {
      if (res.data.isStateChanged) {
        toasterMsg(res.message, 'success');
        return res.data.isStateChanged;
      }
      toasterMsg(res.message, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteMultiUser = (userMultiPayload, transactionMsg) => async () => {
  try {
    const res = await SupplierService.deleteMultiUser(userMultiPayload);
    if (res?.code === 200 && res.data) {
      if (res.data.isUserDeleted) {
        toasterMsg(transactionMsg(res.message), 'success');
        return res.data.isStateChanged;
      }
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// user mangment action method start

export const fetchRightsAssignmentAction = (params) => async () => {
  try {
    const res = await SupplierService.getRightsAssignment(params);

    return res.data;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addUserRightsAssignmentAction = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.addUserRightsAssignment(params);
    if (res?.code === 200) {
      const msg = transactionMsg('SUPPLIER.BACKEND_CONTROLLER.SAVED_SUCCESSFULLY');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllBrandAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllBrands(params);
    if (res.code === 200 && res.data) {
      const allBrands = await res.data.map((item) => {
        return {
          label: item.name,
          value: item._id,
        };
      });
      await dispatch({
        type: t.BRANDS,
        payload: allBrands,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCategoryAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params);
    if (res.code === 200 && res.data) {
      const category = await res.data.map((item) => {
        return {
          label: item.name,
          value: item._id,
        };
      });
      await dispatch({
        type: t.CATEGORY1,
        payload: category,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCategory2Action = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params);
    if (res.code === 200 && res.data) {
      const category2 = await res.data.map((item) => {
        return {
          label: item.name,
          value: item._id,
        };
      });
      await dispatch({
        type: t.CATEGORY2,
        payload: category2,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// user mangment action method end

export const setUserPassword = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.setUserPassword(params);
    if (res?.data && res.code === 200) {
      const msg = transactionMsg(`SUPPLIER.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// supplier documet action method

export const getAllSupplersDocuments = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllDocuments(params);
    if (res?.data && res.code === 200) {
      await dispatch({
        type: t.ALL_SUPPLIER_DOCUMENT_LIST,
        payload: res.data.doc,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const renewSupplerDocument = (params, docId, transactionMsg) => async () => {
  try {
    const res = await SupplierService.renewDocument(params, docId);
    if (res?.data && res.code === 200) {
      const msg = transactionMsg(`SUPPLIER_DOCUMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg.toString()), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const unmountAction = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearUserReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_USER_REDUCER,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getPendingDocumentType = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getPendingDocumentType(params);
    if (res?.data && res.code === 200) {
      const documentAddedTypeList = [];
      res.data.map((n) => !documentAddedTypeList.includes(n.name) && documentAddedTypeList.push(n.name));

      await dispatch({
        type: t.GET_PENDING_TYPE,
        payload: documentAddedTypeList,
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchUserSuppliers = (params) => async () => {
  try {
    const res = await SupplierService.getUserSuppliers(params);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSuppliersTags = () => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierTagData();
    if (res.code === 200) {
      await dispatch({
        type: t.SUPPLIER_TAGS,
        payload: { tags: res.data.tags },
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const registerSupplier = (data, params) => async () => {
  try {
    const res = await SupplierService.registerSupplier(data);
    if (res.code === 200) {
      const mailRes = await SupplierService.checkIfEmailIsVerified(params);
      if (mailRes.code === 200) {
        return mailRes.message;
      }
      toasterMsg(mailRes.data.errMsg, 'danger');
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return null;
};

export const checkIsLinkExpired = (params) => async () => {
  try {
    const res = await SupplierService.checkIsLinkExpired(params);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return null;
};

export const checkIsLinkExpiredForUser = (params) => async () => {
  try {
    const res = await SupplierService.checkIsLinkExpiredForUser(params);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return null;
};

export const setPasswordForSupplierUser = (data, trans) => async () => {
  try {
    const res = await SupplierService.setPasswordForSupplierUser(data);
    if (res.code === 200) {
      /** Carries proof of the redeemed link into the 2FA / security-question screens. */
      storeSetupToken(res?.data?.setupToken);
      if (res?.message) {
        toasterMsg(trans(`SUPPLIER.${res?.message}`), 'success');
      }
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return null;
};

export const getUserList = () => async () => {
  try {
    const res = await SupplierService.getUserList();
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const sendFactoryUpdateLink = (dataObj, transactionMsg) => async () => {
  try {
    const res = await SupplierService.sendFactoryUpdateLink(dataObj);
    if (res.code === 200) {
      if (res?.message) {
        const msg = transactionMsg(`SUPPLIER.${res?.message}`);
        toasterMsg(msg, 'success');
      }
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addSupplierTemplate = (params, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(params);
    let chunkSuccessful = null;
    chunkSuccessful = await SupplierService.insertSupplierTemplate({ data: dataString });
    if (chunkSuccessful && chunkSuccessful.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${chunkSuccessful.message}`);
      toasterMsg(msg, 'success');
    }
    if (chunkSuccessful?.data?.errMsg) {
      const msg = chunkSuccessful.data?.errMsg;
      toasterMsg(transactionMsg(msg?.toString()), 'danger');
    }
    return chunkSuccessful;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateSupplierTemplate = (params, id, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(params);
    let chunkSuccessful = null;
    chunkSuccessful = await SupplierService.editSupplierTemplateById({ data: dataString }, id);
    if (chunkSuccessful?.code === 200) {
      const msg = transactionMsg(chunkSuccessful.message);
      toasterMsg(msg, 'success');
    }
    if (chunkSuccessful?.data?.errMsg) {
      const msg = chunkSuccessful?.data?.errMsg;
      toasterMsg(transactionMsg(msg.toString()), 'danger');
    }
    return chunkSuccessful;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierTemplateById = (libId, pageId, supplierId) => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierTemplateById(libId, pageId, supplierId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SUPPLIER_TEMPLATE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierTemplates = () => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierTemplates();
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SUPPLIER_TEMPLATE,
        payload: res?.data,
      });
    } else {
      const msg = res.data?.errMsg;
      toasterMsg(msg.toString(), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveDocumentTemplate = (params, id, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(params);
    let chunkSuccessful = null;
    chunkSuccessful = await SupplierService.saveSupplierDocumentTemplate({ data: dataString }, id);
    if (chunkSuccessful?.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${chunkSuccessful.message}`);
      toasterMsg(msg, 'success');
    }
    if (chunkSuccessful?.data?.errMsg) {
      const msg = chunkSuccessful?.data?.errMsg;
      toasterMsg(transactionMsg(msg.toString()), 'danger');
    }
    return chunkSuccessful;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editDocumentTemplate = (documetnData, transactionMsg) => async () => {
  const res = await SupplierService.updateDocTemplate(documetnData);
  try {
    if (res?.code === 200) {
      const msg = transactionMsg('SUPPLIER_DOCUMENT.BACKEND_SERVICE.DOCUMENT_UPDATED');
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res?.data?.errMsg}`);
      toasterMsg(msg?.toString(), 'danger');
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const unmountLibrary = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_LIBRARY,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierDocTemplates = (supplierId) => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierDocTemplates(supplierId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_DOCUMENT_TEMPLATE,
        payload: res?.data,
      });
    } else {
      const msg = res.data?.errMsg;
      toasterMsg(msg.toString(), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const archiveUnarchiveDocument = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.archiveUnarchiveDocument(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res.message}`);
      toasterMsg(msg, 'success');
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res?.data?.errMsg}`);
      toasterMsg(msg?.toString(), 'danger');
    }
    return true;
  } catch (err) {
    console.error('archiveUnarchivePim..', err);
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const getAllPartnerOverviewTemplates = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllTemplates(params);

    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_TEMPLATE,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deletePartnerOverviewTemplates = (libIds, objSection, transactionMsg) => async () => {
  try {
    const res = await SupplierService.deletePartnerTemplates(libIds, objSection);
    if (res?.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res?.data?.errMsg}`);
      toasterMsg(msg?.toString(), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_DATA,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const duplicateTemplate = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.duplicateTemplate(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res?.data?.errMsg}`);
      toasterMsg(msg?.toString(), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const markAsCompleteDocument = (data, transactionMsg) => async () => {
  try {
    const res = await SupplierService.markAsComplete(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = t(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const getDocumentTemplateById = (id, pageId) => async (dispatch) => {
  try {
    const res = await SupplierService.getDocumentTemplateByID(id, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SUPPLIER_TEMPLATE_BY_ID,
        payload: res?.data,
      });
    } else {
      const msg = res.data?.errMsg;
      toasterMsg(msg.toString(), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const duplicateDocument = (data, transactionMsg) => async () => {
  try {
    const res = await SupplierService.duplicateDocumnet(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res.message}`);
      toasterMsg(msg, 'success');
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg.toString()), 'danger');
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const updateDocumentTemplate = (documetnData, id, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(documetnData);
    let chunkSuccessful = null;
    chunkSuccessful = await SupplierService.updateDocTemplatewithDocumentId({ data: dataString }, id);
    if (chunkSuccessful?.code === 200) {
      const msg = transactionMsg(`SUPPLIER_DOCUMENT.${chunkSuccessful.message}`);
      toasterMsg(msg, 'success');
    }
    if (chunkSuccessful?.data?.errMsg) {
      const msg = chunkSuccessful.data?.errMsg;
      toasterMsg(transactionMsg(msg.toString()), 'danger');
    }
    return chunkSuccessful;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadTemplate = (params) => async () => {
  try {
    const res = await SupplierService.downloadTemplate(params);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierTemplateForSourceById = (libId, supplierId) => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierTemplateById(libId, supplierId);
    if (res?.code === 200) {
      await dispatch({
        type: t.SOURCE_TEMPLATE,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveLibraryPages = (pagesData) => async (dispatch) => {
  try {
    await dispatch({
      type: t.LIBRARY_PAGES,
      payload: pagesData,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const uploadCMImage = (data) => async () => {
  try {
    const res = await SupplierService.uploadSCMImageS3(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteSCMImage = (data, transactionMsg) => async () => {
  try {
    const res = await SupplierService.deleteSCMImageFromS3(data);
    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`CUSTOM_MODULE.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCMPageList = (libId) => async (dispatch) => {
  try {
    const res = await SupplierService.getPartnerModuleList(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PARTNER_MODULE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getNewMongoId = () => async () => {
  try {
    const res = await SupplierService.getNewPageId();
    if (res.code === 200) {
      return res.data;
    }
    return null;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteTemplatePage = (params, transactionMsg) => async () => {
  try {
    const res = await SupplierService.deleteModuleTemplatePage(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res.data?.errMsg}`);
      toasterMsg(msg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierPageControlList = (customModuleLibId, pageId) => async (dispatch) => {
  try {
    const res = await SupplierService.getPageControls(customModuleLibId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PARTNER_MODULE_PAGE_CONTROL_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierPageList = (libId) => async (dispatch) => {
  try {
    const res = await SupplierService.getPartnerModuleList(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.SUPPLIER_PAGE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updatePageSequence = (data, libId, transactionMsg) => async () => {
  try {
    const res = await SupplierService.updateTemplateSequence(data, libId);
    if (res?.code === 200) {
      const msg = transactionMsg(`PARTNER_OVERVIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getContentPageData = (libId) => async (dispatch) => {
  try {
    const res = await SupplierService.getTemplateContentPage(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SUPPLIER_TEMPLATE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getFilesPageList = (libId) => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierTemplateModuleList(libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PARTNER_MODULE_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// get depdnent Control Lists
export const getDependentPagesList = (customModuleLibId) => async (dispatch) => {
  try {
    const res = await SupplierService.getDependentControlsList(customModuleLibId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PARTNER_MODULE_DEPENDENT_CONTROL_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const refreshSupplierTemplate = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.refreshSupplierTemplate(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PARTNER_MODULE_LIST,
        payload: res?.data,
      });
      return res;
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const refreshSupplierTemplateByPages = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.refreshTemplateWithPages(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PARTNER_MODULE_LIST,
        payload: res?.data,
      });
      return res;
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const copyPageinSupplierFiles = (data) => async () => {
  try {
    const res = await SupplierService.updateCopiedPageInLibrary(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSupplierFileContentPageData = (data) => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierContentPage(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SUPPLIER_TEMPLATE_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getTemplateContentPageData = (libId) => async () => {
  try {
    const res = await SupplierService.getTemplateContentPage(libId);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchFactoriesTags = (supplierId) => async (dispatch) => {
  try {
    const res = await SupplierService.getFactoriesTags(supplierId);
    if (res.code === 200) {
      await dispatch({
        type: t.FACTORIES_TAGS,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const retrieveDocStatus = (params) => async () => {
  try {
    const res = await SupplierService.retrieveDocStatus(params);
    console.log('resres', res);
    if (res?.code === 200) {
      return res?.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchTierSSupplierListAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getTierSSupplier(params);
    if (res.code === 200) {
      switch (params.tierType) {
        case 'Tier1':
          await dispatch({
            type: t.GET_SUPPTIER1,
            payload: res.data,
          });
          break;
        case 'Tier2':
          await dispatch({
            type: t.GET_SUPPTIER2,
            payload: res.data,
          });
          break;
        case 'Tier3':
          await dispatch({
            type: t.GET_SUPPTIER3,
            payload: res.data,
          });
          break;
        case 'Tier4':
          await dispatch({
            type: t.GET_SUPPTIER4,
            payload: res.data,
          });
          break;
        default:
          break;
      }
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
// get calculation Control
export const getSupplierPageCalculationControlList = (customModuleLibId, pageId) => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierPageControls(customModuleLibId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PARTNER_PAGE_CALCULATION_CONTROL_LIST,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// clear calculation Control
export const clearSupplierPageCalculationControlList = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_PARTNER_PAGE_CALCULATION_CONTROL_LIST,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// get all Library Page Data
export const getAllLibraryCalculationPages = (libId) => async (dispatch) => {
  try {
    const res = await SupplierService.getPartnerModuleList(libId, { withoutCP: true });
    if (res?.code === 200) {
      await dispatch({
        type: t.CALCULATION_LIBRARY_PAGES,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
// clear all Library Page Data
export const clearCalculationPages = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CALCULATION_LIBRARY_PAGES,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// get all libraries for the CMs
export const getCalculationSupplierTemplates = () => async (dispatch) => {
  try {
    const res = await SupplierService.getSupplierTemplates();
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SUPPLIER_TEMPLATE_CALCULATION_PAGE,
        payload: res?.data,
      });
    } else {
      const msg = res.data?.errMsg;
      toasterMsg(msg.toString(), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// get all libraries for the CMs
export const clearCalculationSupplierTemplates = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_SUPPLIER_TEMPLATE_CALCULATION_PAGE,
      payload: [],
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearSingleSupplier = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_SINGLE_SUPPLIER,
      payload: null,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchTierSSupplierListData = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getTierSSupplierList(params);
    if (res.code === 200) {
      switch (params.tierType) {
        case 'Tier1':
          await dispatch({
            type: t.GET_SUPPTIERONE,
            payload: res.data,
          });
          break;
        case 'Tier2':
          await dispatch({
            type: t.GET_SUPPTIERTWO,
            payload: res.data,
          });
          break;
        case 'Tier3':
          await dispatch({
            type: t.GET_SUPPTIERTHREE,
            payload: res.data,
          });
          break;
        case 'Tier4':
          await dispatch({
            type: t.GET_SUPPTIERFOUR,
            payload: res.data,
          });
          break;
        default:
          break;
      }
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

/**
 * Export selected suppliers to Excel
 * @param {string[]} selectedIds - Array of selected supplier IDs
 * @param {string} tierType - Tier type (Tier1, Tier2, Tier3, Tier4)
 * @param {Function} t - Translation function
 */
export const exportSelectedSuppliersAction =
  (selectedIds, tierType = 'Tier1', t) =>
  async () => {
    try {
      if (!selectedIds || !Array.isArray(selectedIds) || selectedIds.length === 0) {
        const warningMessage = t ? t('SUPPLIER_OVERVIEW.SELECT_RECORDS_TO_DOWNLOAD') : 'Please select records to download';
        toasterMsg(warningMessage, 'warning');
        return;
      }

      const response = await SupplierService.exportSelectedSuppliers(selectedIds, tierType);
      if (response?.data) {
        const fileName = `Selected_Suppliers_${tierType}_${new Date().getTime()}.xlsx`;
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        fileSaver.saveAs(blob, fileName);
        const successMessage = t
          ? t('SUPPLIER_OVERVIEW.DOWNLOAD_SELECTED_SUCCESS', { count: selectedIds.length })
          : `Downloaded ${selectedIds.length} selected records successfully`;
        toasterMsg(successMessage, 'success');
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errMsg || error?.message || (t ? t('SUPPLIER_OVERVIEW.DOWNLOAD_SELECTED_ERROR') : 'Failed to download selected records');
      toasterMsg(errorMessage, 'danger');
    }
  };

/**
 * Export all suppliers to Excel with current filters
 * @param {Object} params - Export parameters
 * @param {string} params.tierType - Tier type (Tier1, Tier2, Tier3, Tier4)
 * @param {string} [params.searchText] - Search text for filtering
 * @param {string} [params.countryFilter] - Country filter
 * @param {string} [params.supplierTypeFilter] - Supplier type filter
 * @param {Function} t - Translation function
 */
export const exportAllSuppliersAction =
  (params = {}, t) =>
  async () => {
    try {
      const response = await SupplierService.exportAllSuppliers(params);
      if (response?.data) {
        const fileName = `All_Suppliers_${params.tierType || 'Tier1'}_${new Date().getTime()}.xlsx`;
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        fileSaver.saveAs(blob, fileName);
        const successMessage = t ? t('SUPPLIER_OVERVIEW.DOWNLOAD_ALL_SUCCESS') : 'Downloaded all suppliers successfully';
        toasterMsg(successMessage, 'success');
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.errMsg || error?.message || (t ? t('SUPPLIER_OVERVIEW.DOWNLOAD_FAILED') : 'Failed to export suppliers');
      toasterMsg(errorMessage, 'danger');
    }
  };

export const downloadSupplierSampleTemplateAction =
  (transactionMsg, params = {}) =>
  async () => {
    try {
      const response = await SupplierService.downloadSupplierSampleTemplate(params);
      if (response?.data) {
        const fileName = `${params.tierType || 'Tier1'}_Supplier_Sample_Template_${new Date().getTime()}.xlsx`;
        fileSaver.saveAs(response.data, fileName);

        const successMessage = transactionMsg ? transactionMsg('SUPPLIER_OVERVIEW.SAMPLE_DOWNLOAD_SUCCESS') : 'SUPPLIER_OVERVIEW.SAMPLE_DOWNLOAD_SUCCESS';
        toasterMsg(successMessage, 'success');
        return true;
      }
      return false;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errMsg ||
        error?.message ||
        (transactionMsg ? transactionMsg('SUPPLIER_OVERVIEW.SAMPLE_DOWNLOAD_FAILED') : 'SUPPLIER_OVERVIEW.SAMPLE_DOWNLOAD_FAILED');
      toasterMsg(errorMessage, 'danger');
      return false;
    }
  };

export const uploadSupplierFileToS3 = (file, tier) => async () => {
  try {
    const urlResponse = await SupplierService.getSupplierUploadPresignedUrl(file.name, tier);

    if (urlResponse?.code !== 200 || !urlResponse?.data?.presignedUrl) {
      return {
        success: false,
        message: urlResponse?.message ?? 'Failed to get upload URL',
      };
    }

    const { presignedUrl } = urlResponse.data;

    const uploadResponse = await productcp.uploadFileToS3Direct(presignedUrl, file);

    if (!uploadResponse.success) {
      return {
        success: false,
        message: 'Failed to upload file to S3',
      };
    }

    return {
      success: true,
      s3Key: urlResponse.data.s3Key,
      message: 'File uploaded successfully',
    };
  } catch (err) {
    return {
      success: false,
      message: err?.message ?? 'Upload failed',
    };
  }
};

/**
 * Sets a factory's active state and reports the outcome with a toast.
 * @param {string} factoryId - Factory id.
 * @param {string} supplierId - Owning supplier id.
 * @param {boolean} isActive - Target state.
 * @param {Function} transactionMsg - Translation function for the partner-overview namespace.
 * @returns {Function} Thunk resolving to true when the state was stored.
 */
export const updateFactoryActiveStateAction = (factoryId, supplierId, isActive, transactionMsg) => async () => {
  try {
    const res = await SupplierService.updateFactoryActiveState(factoryId, { supplierId, isActive });
    if (res?.code === 200) {
      toasterMsg(transactionMsg('SUPLIER_COMPONENTS.STATE_UPDATED'), 'success');
      return true;
    }
    toasterMsg(transactionMsg('SUPLIER_COMPONENTS.STATE_UPDATE_FAILED'), 'danger');
    return false;
  } catch (err) {
    const messageKey = err?.response?.status === 403 ? 'SUPLIER_COMPONENTS.STATE_UPDATE_FORBIDDEN' : 'SUPLIER_COMPONENTS.STATE_UPDATE_FAILED';
    toasterMsg(transactionMsg(messageKey), 'danger');
    return false;
  }
};

/**
 * Loads the availability of a supplier's factories, keyed by factory id.
 * @param {string} supplierId - Supplier whose factories are listed.
 * @returns {Function} Thunk resolving to `{ [factoryId]: isActive }`, or null (after a toast) when the lookup fails.
 */
export const fetchFactoryActiveStatesAction = (supplierId) => async () => {
  try {
    const res = await SupplierService.getFactoryActiveStates(supplierId);
    if (res?.code !== 200 || !Array.isArray(res?.data)) {
      toasterMsg(i18next.t(FACTORY_STATES_FAILED_KEY, { ns: PARTNER_OVERVIEW_NAMESPACE }), 'danger');
      return null;
    }
    return res.data.reduce((states, entry) => ({ ...states, [entry.factoryId]: entry.isActive }), {});
  } catch (err) {
    toasterMsg(i18next.t(FACTORY_STATES_FAILED_KEY, { ns: PARTNER_OVERVIEW_NAMESPACE }), 'danger');
    return null;
  }
};

/** Generic message for a supplier status change that failed without a translatable reason. */
const SUPPLIER_STATE_FAILED_KEY = 'BACKEND_SERVER.SUPPLIER_SERVICE.SOMETHING_WANT_WRONG';

/** Message for factory statuses that could not be loaded, so callers keep the states they had. */
const FACTORY_STATES_FAILED_KEY = 'SUPLIER_COMPONENTS.STATES_LOAD_FAILED';

/** Namespace holding the partner-overview keys used by these thunks. */
const PARTNER_OVERVIEW_NAMESPACE = 'modules/partner-overview';
